import request from '@/util/request'
import QS from 'qs'
/**
 *获取企业会员首页
 * @returns {AxiosPromise}
 * code：
 0正常可以申请，
 1公司已经申请成功-不能再次申请
 2需确认个人公司信息-跳转相关页面
 3企业已被关联为子企业-不能再次申请
 4您被推荐为该企业的主联系人，是否同意晋升为企业主联系人-跳转相关页面
 5锁定状态-跳转相关页面
 6审核失败-跳转相关页面
 message：相关描述
 */
export function getIndex () {
  return request({
    url: '/rd/companyCenter/index',
    method: 'post'
  })
}

/**
 * 点击申请流程
 * @returns {AxiosPromise}
 *companyDetailsApplyId：申请流程id
 companySimpleId：公司信息id
 applyStep：申请到第几步-跳转相关页面
 email：申请的邮箱
 subCompanyList：关联控股公司
 */
export function applyStep () {
  return request({
    url: '/rd/companyCenter/applyStep',
    method: 'post'
  })
}

/**
 * 企业会员申请流程第一步
 （邮箱认证）
 * @param data
 * companySimpleId：公司id
 email：邮箱
 * @returns {AxiosPromise}
 * code：
 0企业邮箱绑定成功
 1您好，请在您的邮箱内查看邮件进行点击激活操作，无需重复提交~
 2请检验企业邮箱是否是当前绑定的公司
 3请先规范当前企业公司-跳转相关页面
 message：相关信息描述
 */
export function oneStep (data) {
  let q = QS.stringify(data)
  return request({
    url: `/rd/companyCenter/oneStep?${q}`,
    method: 'post'
  })
}

/**
 * 企业会员申请流程第二步
  （邮箱和身份证页面点击下一步调取接口）
 * @param data
   trueMajor:YES是打算直接晋升为主联系人标识
   email：再次校验输入框中的邮件是否是确认状态
 * @returns {AxiosPromise}
 */
export function twoStep (data) {
  let q = QS.stringify(data)
  return request({
    url: `/rd/companyCenter/twoStep?${q}`,
    method: 'post'
  })
}

/**
 * 第二步中发送验证码
 * @param data
 * @returns {AxiosPromise}
 */
export function sendCompanyCode (data) {
  let q = QS.stringify(data)
  return request({
    url: `/rd/companyCenter/sendCompanyCode?${q}`,
    method: 'post'
  })
}

/**
 * 第三步验证验证码
 * @param data
 * mobile：手机号
   code：验证码
 * @returns {AxiosPromise}
 */
export function yanzhengCompanyCode (data) {
  let q = QS.stringify(data)
  return request({
    url: `/rd/companyCenter/yanzhengCompanyCode?${q}`,
    method: 'post'
  })
}

/****
 * 单击解除控股企业
 * @param data
 * subcompanyId：公司id
 * @returns {AxiosPromise}
 */
export function untyingCompany (data) {
  let q = QS.stringify(data)
  return request({
    url: `/rd/companyCenter/untyingCompany?${q}`,
    method: 'post'
  })
}

/***
 * 单击关联控股企业
 * @param data
 * qid：公司id
   companyName：公司名称
   subcompanyName：子公司联系人姓名
   subcompanyEmail：子公司邮箱
 * @returns {AxiosPromise}
 */
export function bindCompany (data) {
  let q = QS.stringify(data)
  return request({
    url: `/rd/companyCenter/bindCompany?${q}`,
    method: 'post'
  })
}

/**
 * 模糊查询公司信息（三字中文起查）
 * @param data
 * name：公司名称
 * @returns {AxiosPromise}
 */
export function findCompanyName (data) {
  let q = QS.stringify(data)
  return request({
    url: `/rd/companyCenter/findCompanyName?${q}`,
    method: 'post'
  })
}

/**
 * 企业会员申请流程第三步
 * @param data
 industry： //所属行业
 registapital： //注册资金
 employeeNumber：//员工人数
 itEmployeeNumber： //it人数
 rdCenter：是否有研发中心(0是 1否)
 privateCloud: //是否有本地数据中心
 mobile: //手机号
 * @returns {AxiosPromise}
 */
export function threeStep (data) {
  let q = QS.stringify(data)
  return request({
    url: `/rd/companyCenter/threeStep?${q}`,
    method: 'post'
  })
}

/****
 * 第一步邮箱认证与第三步邮箱认证合并
 * @param data
 * type  =0 第一步邮箱认证 1第三步认证
   code：标识
 * @returns {AxiosPromise}
 */
export function emailCodeCheck (data) {
  let q = QS.stringify(data)
  return request({
    url: `/rd/companyCenter/emailCodeCheck?${q}`,
    method: 'post'
  })
}

/***
 * 确认个人企业信息
 * @param data
 * companyName ：公司名称
 qid ： 业务id
 state   ：0新公司  1 企业名称不正确（先默认传0）
 * @returns {AxiosPromise}
 */
export function updateCompanyName (data) {
  let q = QS.stringify(data)
  return request({
    url: `/rd/companyCenter/updateCompanyName?${q}`,
    method: 'post'
  })
}

/**
 * 审核失败页面中点击重置申请按钮功能
 * @param data
 * companyDetailsApplyId：申请流程id
 * @returns {AxiosPromise}
 */
export function resettingApply (data) {
  let q = QS.stringify(data)
  return request({
    url: `/rd/companyCenter/resettingApply?${q}`,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/companyCenter.js